import env                                from '../env';
import { fetchJSON }                      from '@statflo/fetch';
import { UserSession }                    from '../types';
import { generateCacheBusterQueryString } from '../helpers/queryStringUtils';

export interface SegmentPayload {
    segmentData: {
        user_id: string,
        name: string,
        email: string,
        firstname: string,
        lastname: string,
        created_at: string,
        phone: string,
        language: string,
        timezone: string,
        status: string,
        job_title: string,
        role: string,
        company: {
            id: string,
            name: string,
            type: string,
            status: string
        },
        language_override: string,
        app_version: string,
        sms_authorized: string
    },
    intercomData: {
        user_hash: string
    }
}

export default async function segmentService(session: UserSession): Promise<SegmentPayload> {
    const requestInit: RequestInit = {
        method: 'GET',
        headers: new Headers({
            Authorization: `Bearer ${session.token}`
        }),
        mode: 'cors',
        cache: 'no-cache'
    };

    const params = generateCacheBusterQueryString({});

    return fetchJSON<SegmentPayload>(`${env.WEBAPP_HOST}api/intercom/?${params}`, requestInit);
}



// WEBPACK FOOTER //
// ./src/services/SegmentService.ts